import {
  GET_ALL_DUONG,
  GET_ALL_PHUONG,
  GET_ALL_QUAN,
  GET_ALL_LOAI_PHONG_BAN,
  GET_ALL_DU_AN,
  GET_ALL_DU_AN_VKT,
  GET_ALL_TEN_LOAI_DAT
} from "../actions/type";

const initialState = {
  listPhuong: [],
  listDuong: [],
  listQuan: [],
  listLoaiPhongBan: [],
  listDuAn: [],
  listTenLoaiDat: [],
  listDuAnVKT: [],
};

const searchReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_QUAN: {
      return {
        ...state,
        listQuan: action.payload,
      };
    }

    case GET_ALL_PHUONG: {
      return {
        ...state,
        listPhuong: action.payload,
      };
    }

    case GET_ALL_DUONG: {
      return {
        ...state,
        listDuong: action.payload,
      };
    }

    case GET_ALL_DU_AN: {
      return {
        ...state,
        listDuAn: action.payload,
      };
    }

    case GET_ALL_DU_AN_VKT: {
      return {
        ...state,
        listDuAnVKT: action.payload,
      };
    }

    // ql nhom nguoi dung
    case GET_ALL_LOAI_PHONG_BAN: {
      return {
        ...state,
        listLoaiPhongBan: action.payload,
      };
    }

    case GET_ALL_TEN_LOAI_DAT: {
      return {
        ...state,
        listTenLoaiDat: action.payload,
      };
    }

    default:
      return state;
  }
};

export default searchReducers;
